import styled from 'styled-components';

export const FileCSVContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: fit-content;
`;

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: fit-content;
  margin-top: 6px;

  border-radius: 4px;

  border: ${(props) => (props.hasFile ? 'none' : '1px dashed #000000')};
`;

export const CurrentFile = styled.div`
  display: ${(props) => (props.hasFile ? 'flex' : 'none')};
`;

export const UploadBar = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 7px;
  gap: 10px;
  font-size: 0.9rem;
  text-align: left;

  > .uploadProgress {
    display: flex;
    height: 7px;
    border-radius: 7px;
    background-color: #ffffff;

    > .uploadProgressFiller {
      display: flex;
      height: 7px;
      border-radius: 7px;
      width: ${(props) => props.progress + '%' || '0'};

      background: ${({ theme }) => theme.color.primary};
    }
  }

  > .fileSizeInfo {
    display: flex;
    justify-content: space-between;
    font-size: 0.7rem;
  }
`;

export const Placeholder = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: fit-content;
  background-color: ${(props) => props.theme.surface10};
`;

export const FileArea = styled.label`
  display: ${(props) => (props.hasFile ? 'none' : 'flex')};
  height: 123px;
  cursor: pointer;

  > input {
    display: none;
  }
`;
